<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
          @title-click="onTabItemClick"
        >
        <template #title="{ data: tab }">
          <div class='sub-title-wrap-tab'>
            <ul>
              <li class='float-left sub-title'>{{tab.title}}</li>
            </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>
    <DailyProductionResultRowComponent ref="refProductResult" :p-type="tabs[selectedIndex].pType" :title="tabs[selectedIndex].title"/>
  </div>
</template>

<script>
import ConstDef from '../../share/ConstDef'
import DxTabPanel from 'devextreme-vue/tab-panel'
import DailyProductionResultRowComponent from './DailyProductionResultRowComponent'

export default {
  name: 'bom-tab',
  data: function () {
    return {
      selectedIndex: 0,
      tabs: [
        {
          title: '완제품 일생산',
          pType: ConstDef.완제품
        },
        {
          title: '반제품 일생산',
          pType: ConstDef.반제품
        },
        {
          title: '디공정품 일생산',
          pType: ConstDef.다공정품
        }
      ]
    }
  },
  components: {
    DxTabPanel,
    DailyProductionResultRowComponent
  },
  created () {
    document.title = ConstDef.TAB_TITLE
    let user = this.$store.getters.getUserInfo
    if (user === undefined || user === null) {
      this.$router.push('/')
    }
    const topMenuTab = this.$store.getters.getTopMenuTabByUrl(this.$route.path)
    if (topMenuTab !== null) {
      const tabNameArray = topMenuTab.multiTabName.split('/')
      for (let i = 0; i < tabNameArray.length; i++) {
        this.tabs[i].title = tabNameArray[i]
      }
    }
  },
  mounted () {

  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onTabItemClick (e) {
      this.$refs.refProductResult.init()
    }
  }
}
</script>

<style lang="scss">

</style>
